import {ViewMode} from "../model/ViewMode"

export const autoSaveTimeout = 2000

class MultilineEditorService {
    getNextMode(curMode: ViewMode): ViewMode {
        if (curMode === ViewMode.NORMAL) {
            return ViewMode.FULL_SCREEN
        }
        if (curMode === ViewMode.FULL_SCREEN) {
            return ViewMode.RIGHT_PANEL
        }
        return ViewMode.NORMAL
    }

    insertIndentAtCursorPosition(
        text: string,
        tryRemove: boolean,
        textArea: HTMLTextAreaElement | null,
        setText: (newText: string) => void) {
        if (textArea === null) {
            return
        }

        const selection = window.getSelection()

        if (!selection) {
            return
        }

        let startOffset = textArea.selectionStart
        while (startOffset > 0) {
            if (text[startOffset] === '\n') {
                startOffset++
                break
            }
            startOffset--
        }

        let endOffset = textArea.selectionEnd
        while (endOffset < text.length - 1) {
            if (text[endOffset] === '\n') {
                break
            }
            endOffset++
        }

        const indentText = ' '.repeat(4)
        const selectedText = text.substring(startOffset, endOffset)
        if (selectedText === '\n') {
            return
        }
        const lines = selectedText.split('\n')
        for (let i = 0; i < lines.length; i++) {
            if (tryRemove) {
                let removeCount = 0
                while (removeCount < indentText.length) {
                    if (lines[i][0] !== ' ') {
                        break
                    }
                    lines[i] = lines[i].substring(1)
                    removeCount++
                }
            } else {
                lines[i] = indentText + lines[i]
            }
        }
        const newText = text.substring(0, startOffset) + lines.join('\n') + text.substring(endOffset)
        const newEndOffset = startOffset + lines.join('\n').length
        setText(newText)
        setTimeout(() => {
            textArea.selectionStart = startOffset
            textArea.selectionEnd = newEndOffset
        })
    }
}

export const multilineEditorService = new MultilineEditorService()
